import {Action, Reducer} from 'redux';
import { IMAGEDELETING, IMAGEDELETEDFAILED,IMAGEDELETED, CLAIMNEWTENDERPERIODLOADING, CLAIMNEWTENDERPERIODLOADED, ADDPARTSLOADING,ADDPARTSLOADED,PARTSLOADING, PARTSLOADED, POLICIESLOADING, POLICIESLOADED,  VEGHICLEMODELLOADING, VEGHICLEMODELLOADED, VEGHICLESUBMODELLOADED, VEGHICLESUBMODELLOADING,PRICEOFFERLOADING, STATUSUPDATING, STATUSUPDATED, PRICEOFFERLOADED,IMAGEUPLOADED,IMAGEUPLOADING, PARTREMOVING, PARTREMOVED, CLAIMLOADING,REPORTLOADING,REPORTLOADED, CLAIMLOADED, CLAIMPARTSLOADING, CLAIMPARTSLOADED, CLAIMUPDATING, CLAIMUPDATED} from './EditClaimDetails.actions';

import {initialState} from './EditClaimDetails.state';

export const EditClaimDetailsReducer: Reducer<any, Action> = ( state = initialState, action: any) => {
    let newState = state

    switch (action.type) {
        case PRICEOFFERLOADING :  newState={...newState,offerLoading:true}; break;
        case PRICEOFFERLOADED :  newState={...newState,offerLoading:false, priceOffer:action.payload}; break;
        case CLAIMLOADING :  newState={...newState,loading:true}; break;
        case CLAIMLOADED :  newState={...newState,loading:false, claim:action.payload}; break;
        case CLAIMUPDATING :  newState={...newState,loading:true}; break;
        case CLAIMUPDATED :  newState={...newState,loading:false}; break;
        case CLAIMPARTSLOADING :  newState={...newState,loading:true}; break;
        case CLAIMPARTSLOADED :  newState={...newState,loading:false, claimParts:action.payload}; break;
        case REPORTLOADING :  newState={...newState,loading:true}; break;
        case REPORTLOADED :  newState={...newState,loading:false, report:action.payload}; break;
        case PARTREMOVING :  newState={...newState,removing:true}; break;
        case PARTREMOVED :  newState={...newState,removing:false, removed:action.payload}; break;
        case IMAGEUPLOADING :  newState={...newState,uploading:true}; break;
        case IMAGEUPLOADED :  newState={...newState,uploading:false, uploaded:action.payload}; break;
        case STATUSUPDATING :  newState={...newState,updating:true}; break;
        case STATUSUPDATED :  newState={...newState,updating:false, updated:action.payload}; break;
        case VEGHICLEMODELLOADING : newState={...newState,loading:true}; break;
        case VEGHICLEMODELLOADED : newState={...newState,loading:false, vehicleModels:action.payload}; break;
        case VEGHICLESUBMODELLOADING : newState={...newState,subModelLoading:true}; break;
        case VEGHICLESUBMODELLOADED : newState={...newState,subModelLoading:false, vehicleSubModels:action.payload}; break;
        case POLICIESLOADING : newState={...newState,lpolyciesLoading:true}; break;
        case POLICIESLOADED : newState={...newState,lpolyciesLoading:false, policies:action.payload}; break;
        case PARTSLOADING : newState={...newState,loading:true}; break;
        case PARTSLOADED : newState={...newState,loading:false, parts:action.payload}; break;
        case ADDPARTSLOADING : newState={...newState,loading:true}; break;
        case ADDPARTSLOADED : newState={...newState,loading:false}; break;
        case CLAIMNEWTENDERPERIODLOADING: newState={...newState,loading:true}; break;
        case CLAIMNEWTENDERPERIODLOADED: newState={...newState,loading:false}; break;
        case IMAGEDELETING :  newState={...newState,deleted:true,uploading:true, loading:true }; break;
        case IMAGEDELETED :  newState={...newState,deleted:false,uploading:false, loading:false}; break;
        case IMAGEDELETEDFAILED :  newState={...newState,deleted:false,uploading:false, loading:false}; break;

    }
    return newState;
};
